export { default } from "./ownerWindow.js";